module.exports = __webpack_public_path__ + "static/media/vehicles-empty.ece2e3b7.svg";